import type { ReactNode } from "react";

import { ChakraProvider } from "@chakra-ui/react";

import { system } from "./theme";

type Props = {
  children: ReactNode;
};
export const ThemeProvider = ({ children }: Props) => {
  return <ChakraProvider value={system}>{children}</ChakraProvider>;
};
